<template>
  <el-card>
    <el-form :model="truck" ref="ruleForm" label-position="top">
      <el-row :gutter="5">
        <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="4">
          <el-form-item :label="$t('tipo-veiculo')" prop="type">
            <el-select v-model="truck.type" placeholder="Veiculo">
              <el-option
                key="bicycle"
                :label="$t('bicicleta')"
                value="bicycle"
              ></el-option>
              <el-option
                key="motorcycle"
                :label="$t('moto')"
                value="motorcycle"
              ></el-option>
              <el-option key="car" :label="$t('carro')" value="car"></el-option>
              <el-option
                key="bus"
                :label="$t('onibus')"
                value="bus"
              ></el-option>
              <el-option key="van" :label="$t('van')" value="van"></el-option>
              <el-option
                key="truck"
                :label="$t('caminhao')"
                value="truck"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5" v-if="!isBicycle">
        <el-col :xs="15" :sm="12" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('placa')" prop="plate" class="is-required">
            <el-input
              ref="plate"
              v-mask="'AAA-####'"
              v-model="truck.plate"
              @blur="validate"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item
            :label="$t('renavam')"
            prop="renavam"
            class="is-required"
          >
            <el-input v-model="truck.renavam"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="14" :md="12" :lg="10" :xl="6">
          <el-form-item :label="$t('cidade')" prop="city" class="is-required">
            <el-input v-model="truck.city"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="10" :md="8" :lg="6" :xl="4">
          <el-form-item :label="$t('estado')" prop="state" class="is-required">
            <StateList v-model="truck.state" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5" v-if="!isBicycle">
        <el-col :xs="14" :sm="12" :md="10" :lg="8" :xl="6">
          <el-form-item label="Chassis" prop="chassis">
            <el-input v-model="truck.chassis"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="8" :sm="6" :md="5" :lg="4" :xl="3">
          <el-form-item :label="$t('ano')" prop="year">
            <YearList
              v-model="truck.year"
              :started="new Date().getFullYear() + 1"
              :max="50"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5" v-if="!isBicycle">
        <el-col :xs="15" :sm="14" :md="12" :lg="7" :xl="5">
          <el-form-item :label="$t('cor')" prop="color">
            <el-input v-model="truck.color"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
          <el-form-item :label="$t('modelo')" prop="model">
            <el-input v-model="truck.model"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
          <el-form-item>
            <el-checkbox v-model="truck.owner"
              >Motorista é o dono do veiculo?</el-checkbox
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5" v-if="!truck.owner">
        <el-col :xs="15" :sm="14" :md="12" :lg="7" :xl="5">
          <el-form-item
            :label="$t('cpf/cnpj')"
            prop="federalid"
            class="is-required"
          >
            <el-input
              v-model="truck.federalid"
              v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="15" :sm="24" :md="24" :lg="14" :xl="8">
          <el-form-item :label="$t('nome')" prop="name">
            <el-input v-model="truck.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="15" :sm="24" :md="24" :lg="8" :xl="8">
          <el-form-item label="Foto veiculo" prop="type">
            <el-upload
              class="avatar-uploader"
              action="/api/services/upload"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="changeFile"
            >
              <img v-if="imageUrl" :src="imageUrl" class="image-service" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="bottom clearfix">
        <el-form-item>
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button type="danger" @click="$emit('close')">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </div>
    </el-form>
  </el-card>
</template>
<script>
import { CouriesService } from "@/services/customers/couries.services";
import { i18n } from "@/plugin/i18n";
import YearList from "./components/YearList";
import StateList from "./components/StateList.vue";
import { ServicesService } from "@/services/customers/services.services";

export default {
  name: "TruckAdd",
  computed: {
    isBicycle() {
      return this.ruleForm.type === "bicycle";
    },
  },
  data() {
    return {
      id: "",
      imageUrl: "",
      ruleForm: {},
      truck: {
        plate: "",
        renavam: "",
        color: "",
        year: new Date().getFullYear(),
        city: "",
        state: "SP",
        chassis: "",
        type: "truck",
        owner: true,
        image: "",
      },
    };
  },

  methods: {
    changeFile(file) {
      this.upload(file);
    },

    validate() {},

    upload(file) {
      const vm = this;
      ServicesService.upload(file)
        .then((response) => {
          this.imageUrl = response.content;
          this.truck.image = response.content;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        });
    },

    back() {
      var vm = this;
      vm.$router.replace({
        name: "couriers",
      });
    },

    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      CouriesService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
          console.log("vm.ruleForm", vm.ruleForm);
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    clearForm() {
      console.log("this.$data", this.$data, this.$options.data());
      Object.assign(this.$data, this.$options.data());
    },

    submitForm(formName) {
      const vm = this;
      console.log("formName", formName, vm.truck);
      // vm.$emit("save", vm.ruleForm);
    },

    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          vm.ruleForm.truck.push(vm.truck);
          const loading = vm.$loading(vm.$options.loading);
          CouriesService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("entregador-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.plate.$el.children[0].focus();
    }
  },
  components: { YearList, StateList },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
